import { apiUrl, authHeaders } from './auth';

export const fetchAdminStats = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/admin/stats';
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  return await resp.json();
};

export const fetchPhotoUpdates = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/admin/photoUpdates';
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  return await resp.json();
};

export const fetchUpcomingEvents = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/admin/upcomingEvents';
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  return await resp.json();
};

export const fetchTopCampaigns = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/admin/topCampaigns';
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  return await resp.json();
};

export type TopReferrer = {
  id: number;
  name: string;
  referrals: number;
};

export type TopReferralSourcesResponse = {
  since: string;
  medical_professionals: TopReferrer[];
  medical_centers: TopReferrer[];
  sources: TopReferrer[];
};

export const fetchTopReferralSources =
  async (): Promise<TopReferralSourcesResponse> => {
    const headers = authHeaders();
    const url = apiUrl + '/admin/topReferralSources';
    const resp = await fetch(url, {
      method: 'get',
      headers,
    });
    if (!resp.ok) {
      throw new Error('Failed to fetch top referral sources');
    }
    return await resp.json();
  };
